import * as React from 'react';

import * as style from './NewReviewModalReview.css';

export const NewReviewModalReview: React.FC<React.PropsWithChildren> = props => {
  const { children } = props;

  return <div className={style['container']}>{children}</div>;
};
